import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import checkValue from '../../../../../../../../utils/values';
import FiduciaPdf from '../../../DownloadPdf/components/FiduciaPdfComponents';

function PdfMonthlyIncome() {
  const incomeFaresState = useSelector(
    (reducer: IReducer) => reducer.incomeFares
  );

  return (
    <>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>
          Tarifas de Manutenções de Contas recebidas:
        </FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.monthly.received).toLocaleString(
            'pt-br',
            {
              style: 'currency',
              currency: 'BRL',
            }
          )}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>
          Tarifas de Manutenções de Contas repassadas:
        </FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.monthly.passedOn).toLocaleString(
            'pt-br',
            {
              style: 'currency',
              currency: 'BRL',
            }
          )}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>
          Receita obtida com Manutenções de Contas:
        </FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.monthly.income).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
    </>
  );
}

export default PdfMonthlyIncome;
